import React, { useState } from "react";
import { SIZE_CHARTS } from "@/data/policies";

const TABS = [
  { k: "tops", label: "TOPS" },
  { k: "bottoms", label: "BOTTOMS" },
  { k: "footwear", label: "FOOTWEAR" },
];

export default function SizeGuide() {
  const [tab, setTab] = useState("tops");
  const chart = SIZE_CHARTS[tab];

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12" data-testid="size-guide-page">
      <div className="mb-10">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">SUPPORT / SIZE GUIDE</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-2 text-black">FIND YOUR FIT.</h1>
        <p className="text-black/60 mt-4 max-w-2xl">
          Measurements are body measurements (not garment). For oversized fits, size down if you want a regular drape.
        </p>
      </div>

      <div className="flex gap-2 mb-8 border-b border-black/10">
        {TABS.map((t) => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            data-testid={`size-tab-${t.k}`}
            className={`px-6 py-3 font-display tracking-widest text-sm border-b-2 -mb-px transition-colors ${
              tab === t.k ? "border-[#FF3B30] text-black" : "border-transparent text-black/50 hover:text-black"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div>
        <h2 className="font-display text-2xl tracking-tighter text-black mb-2">{chart.title}</h2>
        <p className="text-sm text-black/60 mb-6 font-mono">{chart.note}</p>

        <div className="overflow-x-auto border border-black/10">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-black text-white font-display tracking-widest text-xs">
                {chart.cols.map((c) => <th key={c} className="text-left p-3">{c}</th>)}
              </tr>
            </thead>
            <tbody>
              {chart.rows.map((row) => (
                <tr key={row[0]} className={chart.rows.indexOf(row) % 2 ? "bg-black/[0.02]" : ""}>
                  {row.map((cell, j) => (
                    <td key={`${row[0]}-${j}`} className={`p-3 ${j === 0 ? "font-display tracking-widest text-black" : "text-black/75"}`}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-12 border border-black/15 p-6 bg-black/[0.02]">
        <h3 className="font-display text-xl tracking-tighter text-black">HOW TO MEASURE</h3>
        <ul className="mt-3 space-y-2 text-sm text-black/75">
          <li><span className="text-[#FF3B30]">◆ CHEST:</span> Measure under the armpits around the fullest part of your chest.</li>
          <li><span className="text-[#FF3B30]">◆ WAIST:</span> Measure around the narrowest part of your waist (just above belly button).</li>
          <li><span className="text-[#FF3B30]">◆ HIPS:</span> Stand feet together, measure around the fullest part.</li>
          <li><span className="text-[#FF3B30]">◆ INSEAM:</span> Measure from crotch seam down to the ankle bone, along the inside of your leg.</li>
          <li><span className="text-[#FF3B30]">◆ FOOT:</span> Stand on a sheet of paper, mark heel & longest toe, measure in cm.</li>
        </ul>
        <p className="text-xs text-black/50 mt-4 font-mono">Still unsure? WhatsApp us with your measurements and we'll recommend a size.</p>
      </div>
    </div>
  );
}
